import { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { ArrowRight, Send, User } from 'lucide-react';

export const nonSignesApresRelances = (d) => (d?.stagiaires || []).filter((s) => s.statut === 'a_signer' && s.nb_relances >= 3);
const dateFr = (iso) => (iso ? new Date(iso).toLocaleDateString('fr-FR') : '-');

// À traiter : stagiaires qui n'ont toujours pas signé le règlement intérieur après les 3 relances automatiques
export const ReglementsNonSignes = ({ peutEnvoyer }) => {
  const [liste, setListe] = useState(null);
  const [envoi, setEnvoi] = useState(null);
  const charger = useCallback(() => {
    axios.get('/reglement-interieur/suivi').then(({ data }) => setListe(nonSignesApresRelances(data))).catch(() => setListe([]));
  }, []);
  useEffect(() => { charger(); }, [charger]);

  const renvoyer = async (s) => {
    setEnvoi(s.user_id);
    try {
      await axios.post('/reglement-interieur/envoyer', { stagiaire_ids: [s.user_id] });
      toast.success(`Règlement renvoyé à ${s.prenom} ${s.nom} (e-mail + notification)`);
      charger();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Envoi impossible');
    } finally {
      setEnvoi(null);
    }
  };

  if (!liste) return <p className="text-sm text-slate-500">Chargement…</p>;
  return (
    <div className="bg-white border border-slate-200 rounded-xl p-4 sm:p-6 shadow-sm space-y-3" data-testid="reglements-non-signes">
      {liste.length === 0 ? (
        <p className="text-sm text-slate-500">Aucun stagiaire : tous ont signé ou sont encore dans la période de relance.</p>
      ) : liste.map((s) => (
        <div key={s.user_id} className="flex flex-wrap items-center gap-3 p-3 bg-orange-50 rounded-lg border border-orange-200" data-testid={`reglement-non-signe-${s.user_id}`}>
          <User className="h-5 w-5 text-orange-500 shrink-0" />
          <div className="min-w-0 flex-1">
            <p className="font-medium text-[#0F172A] text-sm">{`${s.prenom} ${s.nom}`.trim() || 'Stagiaire'} <span className="font-normal text-slate-400">· {s.session ? `Session ${s.session}` : 'Sans session'}</span></p>
            <p className="text-xs text-slate-600">Envoyé le {dateFr(s.envoye_le)} · {s.nb_relances} relances, la dernière le {dateFr(s.derniere_relance)}</p>
          </div>
          <Link to={`/fiche-stagiaire?id=${s.user_id}`} className="rounded-lg border border-slate-200 bg-white px-2.5 py-1.5 text-xs font-semibold text-slate-700 hover:bg-slate-50" data-testid={`reglement-non-signe-fiche-${s.user_id}`}>Fiche stagiaire</Link>
          {peutEnvoyer && (
            <button type="button" onClick={() => renvoyer(s)} disabled={envoi === s.user_id} data-testid={`reglement-non-signe-renvoyer-${s.user_id}`}
              className="inline-flex items-center gap-1 rounded-lg bg-orange-500 px-2.5 py-1.5 text-xs font-semibold text-white hover:bg-orange-600 disabled:opacity-50">
              <Send className="h-3.5 w-3.5" /> Renvoyer le règlement
            </button>
          )}
        </div>
      ))}
      <Link to="/administratif/reglement-interieur" className="inline-flex items-center gap-1.5 text-sm font-medium text-[#8DC63F] hover:underline" data-testid="reglements-non-signes-lien">
        Voir tous les règlements <ArrowRight className="h-4 w-4" />
      </Link>
    </div>
  );
};
